import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-tickets-current-filter',
  templateUrl: './tickets-current-filter.component.html',
  styleUrls: ['./tickets-current-filter.component.scss'],
  standalone: false,
})
export class TicketsCurrentFilterComponent {
  @Input() ticketsCurrentFilter;
  @Input() brigadeAssign;

  public onChangeTicketType(type): void {
    this.ticketsCurrentFilter.changeTypeSelected(type);
  }

  public assignBrigades(): void {
    this.brigadeAssign.assignBrigades();
  }

  public onChangeMode(mode): void {
    this.ticketsCurrentFilter.onChangeMode(mode);
  }
}
